import React from 'react';
import styled from 'styled-components';

import WorkflowSourceBox from '../WorkflowSourceBox';
import WorkflowTransformationBox from '../WorkflowTransformationBox';
import WorkflowDestinationBox from '../WorkflowDestinationBox';
import FlowArrow from '../FlowArrow';

import { WorkflowItemDetailProps } from './types';

const StyledContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const WorkflowItemDetail = ({
  isOpen,
  workflow,
}: WorkflowItemDetailProps) => (
  <StyledContainer>
    <WorkflowSourceBox isOpen={isOpen} sources={workflow.sources} />
    <FlowArrow hideLabel={isOpen} label='Indicators' />
    <WorkflowTransformationBox isOpen={isOpen} transformations={workflow.transformations} />
    <FlowArrow hideLabel={isOpen} label='Score Indicators' />
    <WorkflowDestinationBox isOpen={isOpen} workflow={workflow} />
  </StyledContainer>
);

export default WorkflowItemDetail;
